import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stockMovements: [],
    loading: false,
    error: null,
};

const stockMovementSlice = createSlice({
    name: 'stockMovement',
    initialState,
    reducers: {
        setStockMovements: (state, action) => {
            state.stockMovements = action.payload;
        },
        addStockMovement: (state, action) => {
            state.stockMovements.push(action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setStockMovements, addStockMovement, setLoading, setError } = stockMovementSlice.actions;
export default stockMovementSlice.reducer;
